<template>
    <div class="listbrdr pointer">
        <router-link :to="link" exact class="menu-item" :class="{' active ': isActive}">
            <i class="leftmenu_icon" :class="icon"></i>
            <span class="name"><slot></slot></span>
            <i v-if="exclamation"
                class="fa fa-lg fa-exclamation red-icon float-right"
                aria-hidden="true"
            ></i>
        </router-link>
    </div>
</template>
<script>
export default {
    props: ["link", "icon", "exclamation", "exclusion"],
    computed: {
        isActive: function () {
            let baseRoute = this.link.split('/').join('.').substr(1);
            return this.$route.name.includes(baseRoute) && !this.$route.fullPath.includes(this.exclusion);
        }
    },
}

</script>
<style scoped lang="scss">
@import "../../../css/customvariables";
a {
    color: $menu_color;
    position: relative;
    display: block;
    line-height: 21px;
    padding: 10px 30px;
    &:hover {
        color: $menu_hover_color;
    }
    &.active {
        color: $menu_active_color;
        background-color: $menu_active;
        i {
            color: $active_icon;
        }
    }
}

.leftmenu_icon.ti-dark-circle{
    vertical-align:middle
}

.submenu-content-box .listbrdr:active{
    color: #000;
}
.submenu-content {
    a {
        padding: 11px 20px 10px 45px;
        position: relative;
    }
    .leftmenu_icon {
        font-size: 10px;
        color:inherit;

    }
}

.name {
    vertical-align: text-bottom;
}

.collapse-item .card-content .card-content-box div a {
    padding-left: 43px;

}

.leftmenu_icon {
    margin-right: 10px;
    line-height: 22px;
    height: 23px;
    width: 20px;
    text-align: center;
    font-size: 16px;
    color:$menu_color;

}

.fa.fa-lg.fa-exclamation.red-icon {
    padding-top: 5px;
    color: red !important
}
</style>
